import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  branches: {
    selectedBranch: {
      id: localStorage.getItem('branchId'),
      name: ''
    }
  }
};

/**
 * Get only - Basic
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
 export const getAllActiveBranches = createAsyncThunk(
  'branch/GetActiveBranches',
  async (thunkAPI) => {
    try {
      const response = await axios.get(`${apiBaseURL}/api/v1/branches/active`);
      return response.data.branches;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const slice = createSlice({
  name: 'branches',
  initialState,
  reducers: {
    getBranches(state, action) {
      const { branches } = action.payload;
      state.branches = action.payload;
    },
    setBranch(state, action) {
      const { branch } = action.payload;
      state.selectedBranch = branch;
    }
  },
  extraReducers: {
    [getAllActiveBranches.pending]: (state, action) => {
      state.getStatus = 'loading';
    },
    [getAllActiveBranches.fulfilled]: (state, action) => {
      state.branches = action.payload;
      state.getStatus = 'success';
    },
    [getAllActiveBranches.rejected]: (state, action) => {
      state.getStatus = 'failed';
    },
  },
});

export const reducer = slice.reducer;

export const setBranch = branch => async dispatch => {
  const readyObject = {
    branch
  };
  
  dispatch(slice.actions.setBranch(readyObject));
};

export const getBranches = () => async dispatch => {
  const response = await axios.get(`${apiBaseURL}/api/v1/branches/`);
  // console.log('getBranches', response.data.branches);
  dispatch(slice.actions.getBranches(response.data.branches));
};

export default slice;
